export const INSTRUCTION_TXT = '(">>" means started)';
export const MARKDOWN_PREFIX = '[MARKDOWN]';
export const TITLE = `### **Daily planner** ${INSTRUCTION_TXT}\n`;
export const INITIAL_MARKDOWN = `${TITLE}Task Group 1\n* [ ] Todo`;
export const VIVARA_INITIAL_MARKDOWN = 'Task Group 1\n* [ ] Todo';
